// extracted by mini-css-extract-plugin
module.exports = {"methodsList":"MethodsList_methodsList__3oDit"};